import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=38dfbb7a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dfbb7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dfbb7a')) {
      api.createRecord('38dfbb7a', component.options)
    } else {
      api.reload('38dfbb7a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=38dfbb7a&scoped=true&", function () {
      api.rerender('38dfbb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25RdJoHRAjtN7/JS/comp/Accordion.vue"
export default component.exports